import text from './resources/locale/en.json';

class PreferencesGuidelines {
    $onInit() {
        this.text = text;
    }
}

export default PreferencesGuidelines;
